<template>
  <div class="item">
    {{ name }}
  </div>
</template>

<script>
export default {
  name: 'facility',
  props: {
    name: {
      type: String,
      default: '',
    },
  },
};
</script>

<style scoped lang="scss">
.item {
  position: relative;
  color: #6e7c91;
  font-size: 14px;
  font-weight: 500;
  line-height: 16px;
}
</style>
